import React, { useEffect, useState } from "react";
import { Box, Grid, Typography, Button, Skeleton } from "@mui/material";
import ApiService from "./../../services/api-service";
import { useHistory } from "react-router-dom";
import RobotAnimation from "../../components/Homev2/RobotAnimation";

const BannerSection = () => {
  const [bannerData, setBannerData] = useState(null);
  const [loading, setLoading] = useState({ banner: false });
  const [mediaBanners, setMediaBanners] = useState([]);
  const [currentBannerIndex, setCurrentBannerIndex] = useState(0);
  const history = useHistory();

  const fetchBannerData = async () => {
    setLoading((prev) => ({ ...prev, banner: true }));
    try {
      // Fetch uploaded banners
      const bannerResponse = await ApiService.GET_MEDIA_BANNERS();
      if (bannerResponse.result && bannerResponse.result.data) {
        setMediaBanners(bannerResponse.result.data);
      }

      // Fetch other data
      const songResponse = await ApiService.MUSIC_MOST_STREAM_WEEK();
      const playlistResponse = await ApiService.PLAYLIST_STREAMED();

      setBannerData({
        mostStreamedSong: songResponse.result?.[0],
        mostStreamedPlaylist: playlistResponse.result?.[0],
      });
    } catch (error) {
      console.error("Error fetching banner data:", error);
    } finally {
      setLoading((prev) => ({ ...prev, banner: false }));
    }
  };

  useEffect(() => {
    fetchBannerData();
  }, []);

  // Auto-rotate banners if multiple
  useEffect(() => {
    if (mediaBanners.length > 1) {
      const interval = setInterval(() => {
        setCurrentBannerIndex((prev) => (prev + 1) % mediaBanners.length);
      }, 5000); // Change banner every 5 seconds
      return () => clearInterval(interval);
    }
  }, [mediaBanners.length]);

  if (!bannerData) return null;

  return (
    <Box sx={{ width: "100%", padding: "20px" }}>
      {/* Bottom Section: Hedera Banner */}
      <Box
        component="a"
        href="https://hedera.com/"
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          width: "100%",
          height: "100px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "16px",
          padding: "20px",
          marginTop: 3,
          background: `linear-gradient(145deg, var(--background-color, #000000), var(--paper-color, #1E1E1E))`,
          backdropFilter: "blur(12px)",
          boxShadow: "0px 8px 30px rgba(0, 0, 0, 0.8)",
          border: `1px solid var(--accent-color, #262626)`,
          position: "relative",
          overflow: "hidden",
          textDecoration: "none",
          cursor: "pointer",
        }}
      >
        {/* Background Design Elements */}
        <Box
          sx={{
            position: "absolute",
            top: "10%",
            left: "5%",
            width: "60px",
            height: "60px",
            borderRadius: "50%",
            background: "rgba(255, 255, 255, 0.08)",
            filter: "blur(20px)",
          }}
        />
        <Box
          sx={{
            position: "absolute",
            bottom: "10%",
            right: "5%",
            width: "80px",
            height: "80px",
            borderRadius: "50%",
            background: "rgba(255, 255, 255, 0.12)",
            filter: "blur(30px)",
          }}
        />

        {/* Content */}
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            fontFamily: "'Inter', sans-serif",
            letterSpacing: "1px",
            textTransform: "uppercase",
            color: "var(--text-primary, #FFFFFF)",
            textShadow: "0px 4px 10px rgba(255, 255, 255, 0.2)",
            zIndex: 1,
            mr: 3,
          }}
        >
          Powered by
        </Typography>
        <Box
          sx={{
            width: "60px",
            height: "60px",
            zIndex: 1,
            color: "var(--text-primary, #FFFFFF)",
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1200 1200"
            style={{ width: "100%", height: "100%" }}
          >
            <defs>
              <style>
                {`.cls-1{fill:currentColor;stroke-width:0px;}`}
              </style>
            </defs>
            <g id="Icon">
              <path
                id="Icon-2"
                className="cls-1"
                d="M431.22,556.89h337.64v86.23h-337.64v-86.23ZM1200,600c0,331.37-268.63,600-600,600S0,931.37,0,600,268.63,0,600,0s600,268.63,600,600ZM847.9,330.54h-79.04v168.86h-337.64l-.09.09v-168.95h-79.04v538.92h79.04v-169l.09.14h337.64v168.86h79.04V330.54Z"
              />
            </g>
          </svg>
        </Box>
      </Box>
    </Box>
  );
};

export default BannerSection;
